import { datadogRum } from '@datadog/browser-rum';

export enum CardType {
  Finance = 'finance',
  Trade = 'trade'
}

export function fireAction(card: CardType) {
  switch (card) {
    case CardType.Finance:
      datadogRum.addAction('Finance cta', { action: 'clicked' });
      break;
    case CardType.Trade:
      datadogRum.addAction('Trade cta', { action: 'clicked' });
      break;
  }
}
